import { render } from "./NewAsideClimate.vue?vue&type=template&id=5c5823ae&scoped=true"
import script from "./NewAsideClimate.vue?vue&type=script&lang=js"
export * from "./NewAsideClimate.vue?vue&type=script&lang=js"

import "./NewAsideClimate.vue?vue&type=style&index=0&id=5c5823ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5823ae"]])

export default __exports__